import './Breadcrumbs.css';
import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderModuleWrapper from './HeaderModuleWrapper';
import IconChevronRight from '../atoms/Icons/IconChevronRight';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc } from '../../utils/tealium';
import { getDictionaryItem } from '../../utils';
var Breadcrumbs = function Breadcrumbs(_ref) {
  var mobileLabel = _ref.mobileLabel,
    location = _ref.location,
    breadcrumbAnalytics = _ref.breadcrumbAnalytics,
    dictionary = _ref.dictionary,
    _ref$userProfile = _ref.userProfile,
    userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLocation = location && location.pathname ? location.pathname : undefined;
  var breadcrumb = sitecoreContext.breadcrumb;
  var breadcrumbsAccessibilityTitle = getDictionaryItem(dictionary && dictionary.commonDictionary, 'breadcrumbs') || 'Breadcrumbs';
  if (!breadcrumb || breadcrumb.length <= 1) {
    return null;
  }
  var previousLevelPage = breadcrumb.length >= 2 ? breadcrumb[breadcrumb.length - 2] : undefined;
  var previousLevelUrl = previousLevelPage && previousLevelPage.url ? previousLevelPage.url : '/';
  var previousLevelLabel = previousLevelPage && previousLevelPage.label ? previousLevelPage.label : mobileLabel;
  var breadcrumbCssClass = 'breadcrumb-nav';
  var replacePlaceholders = function replacePlaceholders(label) {
    if (label.indexOf('#username#') > -1) {
      var firstName = userProfile.firstName,
        lastName = userProfile.lastName;
      return label.replace('#username#', "".concat(firstName, " ").concat(lastName));
    }
    return label;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: breadcrumbCssClass
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n        {\n          \"@context\": \"https://schema.org\",\n          \"@type\": \"BreadcrumbList\",\n          \"itemListElement\": [\n            ".concat(breadcrumb.map(function (b, index) {
        return "{\n                  \"@type\": \"ListItem\",\n                  \"position\": ".concat(index + 1, ",\n                  \"name\": \"").concat(b.label && b.label.replace(/"/g, "'"), "\",\n                  \"item\": \"").concat(sitecoreContext && sitecoreContext.origin).concat(b.url, "\"\n                }");
      }), "\n          ]\n        }")
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: "breadcrumb"
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, breadcrumbsAccessibilityTitle), breadcrumb.map(function (b, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "breadcrumb__list"
    }, currentLocation && b.url.toLowerCase() === currentLocation.toLowerCase() ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: replacePlaceholders(b.label)
      }
    }) : /*#__PURE__*/React.createElement("a", {
      href: b.url,
      title: b.label,
      className: "link",
      onClick: function onClick() {
        tealiumClickFunc(breadcrumbAnalytics, b.enLabel);
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: b.label
      }
    })), index < breadcrumb.length - 1 && /*#__PURE__*/React.createElement(IconChevronRight, {
      className: "breadcrumb__list-icon"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb__back"
  }, /*#__PURE__*/React.createElement("a", {
    className: "breadcrumb__back-link",
    href: previousLevelUrl
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    rtl: rtl
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: previousLevelLabel
    }
  }))));
};
export default withRouter(Breadcrumbs);
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "cuqupq4";
var ltrStyles = "l1o46kfz";
var rtlStyles = "roq3hbm";